import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import PrismicVue from 'prismic-vue'
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'

import VueWait from 'vue-wait'

import Vue2TouchEvents from 'vue2-touch-events'

import VueAnalytics from 'vue-analytics'

Vue.use(Vue2TouchEvents)

Vue.use(VueWait)

Vue.use(VueAnalytics, {
  id: 'UA-158294556-1'
})

Vue.config.productionTip = false

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer
})

new Vue({
  router,
  store,
  wait: new VueWait({
    useVuex: true
  }),
  render: function (h) { return h(App) }
}).$mount('#app')
